import { defaultDirection } from '../constants/defaultValues';

export const mapOrder = (array, order, key) => {
    array.sort(function (a, b) {
        var A = a[key],
            B = b[key];
        if (order.indexOf(A + '') > order.indexOf(B + '')) {
            return 1;
        } else {
            return -1;
        }
    });
    return array;
};

export const getDateWithFormat = () => {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    return dd + '.' + mm + '.' + yyyy;
};

export const getCurrentTime = () => {
    const now = new Date();
    return now.getHours() + ':' + now.getMinutes();
};

export const getDirection = () => {
    let direction = defaultDirection;
    if (localStorage.getItem('direction')) {
        const localValue = localStorage.getItem('direction');
        if (localValue === 'rtl' || localValue === 'ltr') {
            direction = localValue;
        }
    }
    return {
        direction,
        isRtl: direction === 'rtl',
    };
};

export const setDirection = (localValue) => {
    let direction = 'ltr';
    if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
    }
    localStorage.setItem('direction', direction);
};

/**
 * @method
 * @param {integer} ElementId is the id name from the element html where go to set the messageToHTML
 * @param {integer} messageToHTML is the message type String
 * @description function responsable of setter a message into of the ElementId defined
 */
export const transformText2HTML = (ElementId, messageToHTML) => {
    if (messageToHTML) {
        const element = document.getElementById(ElementId);
        if (element) {
            element.innerHTML = messageToHTML;
        }
    }
};

/**
 * @method
 * @param {String} nameObj is the name for to save in the storage
 * @param {Object} obj is the object to send to the storage
 * @description function responsable of send object to storage
 */
export function saveStorage(nameObj, obj) {
    localStorage.setItem(nameObj, JSON.stringify(obj));
    return true;
}

/**
 * @method
 * @param {integer} nameObj  is the name for get info in the storage
 * @description function responsable of get object from storage
 */
export function getStorage(nameObj) {
    var obj = {};

    if (typeof localStorage[nameObj] !== 'undefined') {
        if (localStorage[nameObj] !== 'undefined') {
            localStorage[nameObj].length > 0
                ? (obj = JSON.parse(localStorage[nameObj]))
                : (obj = localStorage[nameObj]);
        }
    }
    return obj;
}

/**
 * @method
 * @param {String} stringText is the string from we want to get the number
 * @description function responsable of return a number from a string text
 */
export function getNumberFromString(stringText) {
    let numberFromString = 0;

    for (let i = 0; i < stringText.length; i++) {
        //Use isNaN() to check if the value is a number.
        if (isNaN(stringText[i]) === false) {
            numberFromString = stringText[i];
        }
    }

    return numberFromString;
}

/**
 * @method
 * @param {Number} height is the number of the actual screen height
 * @param {Number} maxHeight is.........
 * @description function responsable of return a vertical height number
 */
export function getVerticalHeight(height, maxHeight) {
    /**
     * Formula details values:
     * heightInfo => actual screen height
     * 100 => 100% of the screen
     * maxHeight => max value of vertical height in the 100% of screen height
     */
    return (height * 100) / maxHeight;
}

export function accessValue(object, key) {
    let content = object;
    if (key.split('.').length > 1) {
        const items = key.split('.');
        items.forEach((data) => {
            if (content) {
                content = content[data];
            }
        });
    } else {
        content = content[key];
    }
    return content;
}

export function accessValueDependency(dependency) {
    let dependencie = dependency;
    if (dependencie !== undefined && dependencie.split('.').length > 1) {
        const dependencies = dependency.split('.');
        dependencie = dependencies[dependencies.length - 1];
    } else {
        return dependencie;
    }
    return dependencie;
}

export const LightenDarkenColor = (col, amt) => {
    var usePound = false;

    if (col[0] === '#') {
        col = col.slice(1);
        usePound = true;
    }

    var num = parseInt(col, 16);

    var r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    var b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    var g = (num & 0x0000ff) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

/**
 * @method
 * @param {Array} arrTextConditionList is array of strings that go to order from list to list text
 * @description function responsable of return a text from a list of array of strings
 */
export const getListText = (arrTextConditionList) => {
    if (arrTextConditionList.length > 0) {
        if (arrTextConditionList.length === 1) {
            return arrTextConditionList.join(' ');
        } else {
            const letterConector =
                arrTextConditionList[arrTextConditionList.length - 1][0] === 'i'
                    ? 'e'
                    : 'y';

            if (
                arrTextConditionList.length > 1 &&
                arrTextConditionList.length <= 2
            ) {
                arrTextConditionList.splice(
                    arrTextConditionList.length - 1,
                    0,
                    letterConector
                );
                return arrTextConditionList.join(' ');
            } else {
                let addComma = arrTextConditionList.map((element, index) => {
                    if (
                        arrTextConditionList.length - 1 === index ||
                        arrTextConditionList.length - 2 === index
                    ) {
                        return element;
                    } else {
                        return element + ',';
                    }
                });

                addComma.splice(
                    arrTextConditionList.length - 1,
                    0,
                    letterConector
                );
                return addComma.join(' ');
            }
        }
    }
};

export const apiAuthorization = (PermissionClient, PermissionProcess) => {
    if (PermissionClient && PermissionProcess) {
        let headers = {
            'Permission-Client': PermissionClient,
            'Permission-Process': PermissionProcess,
        };

        return headers;
    }
};

/**
 * The function assigns a value from one parameter in an object to another parameter in the same
 * object.
 * @param object - The object parameter is the object from which we want to assign a value to another
 * object.
 * @param paramToUpdate - The parameter `paramToUpdate` is the name of the property in the `object`
 * that you want to update with the value from `paramGetData`.
 * @param paramGetData - The parameter `paramGetData` is the name of the parameter in the object that
 * you want to get the value from.
 */
function assignValueToOneObjectFromAnotherObject(
    object,
    paramToUpdate,
    paramGetData
) {
    for (let parametro in object) {
        if (parametro === paramGetData) {
            object[paramToUpdate] = object.direccion_homologada;
            break;
        }

        if (typeof object[parametro] === 'object') {
            assignValueToOneObjectFromAnotherObject(
                object[parametro],
                paramToUpdate,
                paramGetData
            );
        }
    }
}

/**
 * The function reformatAddress takes an array of addresses and assigns the value of one property to
 * another property in each address object.
 * @param addressArr - An array of objects representing addresses. Each object should have a property
 * called 'direccion' which represents the original address, and a property called
 * 'direccion_homologada' which represents the reformatted address.
 * @returns the modified `addressArr` array after assigning the value of the `direccion` property to
 * the `direccion_homologada` property for each element in the array.
 */
export const reformatAddress = (addressArr) => {
    addressArr.forEach((elemento) => {
        assignValueToOneObjectFromAnotherObject(
            elemento,
            'direccion',
            'direccion_homologada'
        );
    });
    return addressArr;
};

/**
 * The `reduceImageWeight` function reduces the weight of a base64 image by resizing it and converting
 * it to a lower quality JPEG format.
 * @param base64Image - The base64Image parameter is a string that represents the image data in base64
 * format. It is the encoded version of the image file.
 * @param [maxWidth=700] - The maximum width that the image should have after resizing. If the original
 * image width is greater than this value, it will be resized proportionally to fit within this width.
 * @param [maxHeight=700] - The maxHeight parameter is used to specify the maximum height that the
 * image should have after resizing. If the original image height is greater than the maxHeight value,
 * the image will be resized proportionally to fit within the specified maxHeight.
 * @param [quality=1] - The "quality" parameter determines the level of compression applied to the
 * image when converting it back to base64 format. A value of 1 represents the highest quality with no
 * compression, while a value less than 1 (e.g., 0.8) applies compression to reduce the file size.
 * @returns a reduced base64 image with a lower weight.
 */
export async function reduceImageWeight(
    base64Image,
    maxWidth = 700,
    maxHeight = 700,
    quality = 1
) {
    const img = new Image();

    // Esperar a que la imagen se cargue para continuar
    try {
        await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = base64Image;
        });

        const canvas = document.createElement('canvas');
        let { width, height } = img;

        // Redimensionar la imagen si es necesario
        if (maxWidth && width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
        }

        if (maxHeight && height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convertir la imagen nuevamente a base64 con menor peso
        const reducedBase64Image = canvas.toDataURL('image/jpeg', quality);

        return reducedBase64Image;
    } catch (error) {
        throw new Error('Error al cargar la imagen.');
    }
}

/**
     * @method
     * @param {Object} url is the url or base64
     * @param {Object} filename is the file name
     * @param {Object} mimeType is the mime type from the file
     * @description function responsable of return a File type
     * @example:
        urltoFile('data:text/plain;base64,aGVsbG8gd29ybGQ=', 'hello.txt','text/plain')
        .then(function(file){ console.log(file);});
     */
export function urltoFile(url, filename, mimeType) {
    return fetch(url)
        .then(function (res) {
            return res.arrayBuffer();
        })
        .then(function (buf) {
            return new File([buf], filename, { type: mimeType });
        });
}

/**
 * The function replaces a specific key with a new key in an object or an array of objects.
 * @param object - The object parameter is the object or array that you want to replace the key in.
 * @param oldKey - The oldKey parameter is the key that you want to replace in the object.
 * @param newKey - The `newKey` parameter is the new key that you want to replace the old key with in
 * the object.
 * @returns the modified object with the old key replaced by the new key.
 */
export function replaceKeyFromObject(object, oldKey, newKey) {
    if (object instanceof Array) {
        for (let i = 0; i < object.length; i++) {
            object[i] = replaceKeyFromObject(object[i], oldKey, newKey);
        }
    } else if (object instanceof Object) {
        const newObject = {};
        for (const key in object) {
            if (key.includes(oldKey)) {
                newObject[key.replace(oldKey, newKey)] = object[key];
            } else {
                newObject[key] = replaceKeyFromObject(
                    object[key],
                    oldKey,
                    newKey
                );
            }
        }
        return newObject;
    }
    return object;
}

/**
 * The function `checkCameraPermissions` checks if the user has granted access to the camera and
 * returns a stream if successful, or an error message if not.
 * @returns The function `checkCameraPermissions` returns a promise that resolves to a stream object if
 * the camera permissions are granted and available. If the permissions are denied or there is no
 * camera available, it returns an object with an error message. If there is any other error while
 * accessing the camera, it returns an object with an error message including the specific error.
 */
export async function checkCameraPermissions() {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: true,
        });

        return stream;
    } catch (error) {
        if (
            error.name === 'NotAllowedError' ||
            error.name === 'NotFoundError'
        ) {
            return {
                error: 'Hubo un problema al capturar la imagen, valide si tiene activados los permisos de la cámara.',
            };
        }
    }
}

export function filterReports({ categoria, fields }) {
    // Objeto que contiene las configuraciones de filtros para cada categoría
    const categoriaFiltros = {
        fechas: ['fecha_desde', 'fecha_hasta', 'tipo_reporte'],
        subproductos: [
            'fecha_desde',
            'fecha_hasta',
            'subproductos',
            'oficinas',
            'tipo_reporte',
        ],
        ano_mes: ['year', 'month', 'tipo_reporte'],
        no_fields: ['tipo_reporte'],
        oficinas: ['oficinas', 'tipo_reporte', 'ejecutivos'],
        productos_fechas: [
            'fecha_desde',
            'tipo_reporte',
            'fecha_hasta',
            'productos',
        ],
        fecha_cierre: ['fecha_cierre_mes', 'tipo_reporte'],
        ano_mes_subprodc: ['year', 'month', 'tipo_reporte', 'subproductos'],
        subproducto_oficina: ['oficinas', 'tipo_reporte', 'subproductos'],
        regionales: ['regionales', 'tipo_reporte', 'producto', 'estados'],
        fecha_estado: ['fecha_desde', 'fecha_hasta', 'tipo_reporte', 'estados'],
        fechas_oficinas: [
            'tipo_reporte',
            'oficinas',
            'fecha_desde',
            'fecha_hasta',
        ],
        fechas_hora: ['fecha_desde_hora', 'fecha_hasta_hora', 'tipo_reporte'],
    };

    // Filtrar los campos en función de la categoría
    const filtros = categoriaFiltros[categoria] || [];

    return fields.filter((field) => filtros.includes(field.name));
}

export function validateValueExist(value) {
    if (value) {
        return value;
    }
    return 'SIN INFORMACIÓN';
}

export function capitalizeText(text) {
    return text
        .toLowerCase() // Convierte todo a minúsculas
        .replace(/(^|\s)\S/g, (char) => char.toUpperCase()); // Capitaliza cada palabra
}
